export default __webpack_public_path__ + "static/media/down-pointing-hand.4b89d550.svg";